import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Firebase SW registered: ', registration);
    })
    .catch((registrationError) => {
      console.log('Firebase SW registration failed: ', registrationError);
    });
}

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
